import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const GET_CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
